<script>
export default {
  props: {
    searchText: String,
  },
  mounted() {
    this.$nextTick(() => this.$refs.searchInput.focus())
  },
}
</script>

<template lang="pug">
.form-group.mb-0.mr-2
  input(
    ref="searchInput"
    :placeholder="$t('search.placeholder')"
    :value="searchText"
    @keyup="$emit('updateSearchText', $event)"
    type="text"
  )
</template>

<style scoped lang="scss"></style>
